import {Row} from "antd";
import React, {useState, useRef, useEffect} from "react";
import {Button, Form} from "antd";
import {FormBox, InputBox} from "../../../../components/AntdAddons";
import {ReactComponent as ArrowRight} from "../../../../assets/images/icon/backToTop.svg";
import ReCAPTCHA from "react-google-recaptcha";
import {randomnumbersubstring} from "../../../../utils/GlobalFunction";
// import {Notification} from "../../../../config/Global";
import {createDeleteAccountRecord} from "../../../../store/CommonSlice";
import {useAppDispatch} from "../../../../store/app";
import {assignErrorToInput} from "../../../../store/api";

const DeleteAccount: React.FC<any> = () => {
    const [form] = Form.useForm();
    const [disabledSave, setDisabledSave] = useState(true);
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const dispatch = useAppDispatch();

    const onChange = (value: string | null) => {
        if (value) {
            setDisabledSave(false); // Enable the button when the reCAPTCHA is completed
        } else {
            setDisabledSave(true); // Disable the button when the reCAPTCHA is not completed
        }
    };

    const resetCaptcha = () => {
        form.setFieldsValue({captcha: randomnumbersubstring()});
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
            setDisabledSave(true); // Disable the button when the reCAPTCHA is reset
        }
    };

    useEffect(() => {
        form.setFieldsValue({captcha: randomnumbersubstring()});
    }, [form]);

    const handleDeleteAccountSubmit = (values: any) => {
        // Handle form submission logic here
        setDisabledSave(true);
        dispatch(createDeleteAccountRecord(values))
            .then(() => {
                form.resetFields();
                resetCaptcha();
                setDisabledSave(false);
            })
            .catch((error: any) => {
                assignErrorToInput(form, error?.messages);
            })
            .finally(() => setDisabledSave(false));
        // Notification.success({
        //     message: "Your delete account request submitted successfully, We will process on it",
        // });
    };

    return (
        <>
            <section className="section whyThisSection signSection" id="kapturely">
                <div className="container">
                    <Row className="heading">
                        <h2>Delete Account</h2>
                    </Row>
                    <Row className="signUp">
                        <div className="footerForm">
                            <FormBox form={form} onFinish={handleDeleteAccountSubmit}>
                                <InputBox.Text placeholder="Email" name="email" required />
                                <InputBox.Password
                                    placeholder="Password"
                                    name="password"
                                    required
                                />
                                <div className="captchaWrap">
                                    <Form.Item name="captcha">
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6LeE4uopAAAAAAQo2aZ7_MtMWuBPvlzPgUSei22O" // site key
                                            onChange={onChange}
                                        />
                                    </Form.Item>
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        position: "relative",
                                        zIndex: "9999",
                                    }}
                                >
                                    <Button
                                        className="commanBtn"
                                        htmlType="submit"
                                        disabled={disabledSave}
                                    >
                                        <span className="arrowIcon">
                                            <ArrowRight />
                                        </span>
                                        <span className="beforeIcon"></span>
                                        Submit
                                    </Button>
                                </div>
                            </FormBox>
                        </div>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default DeleteAccount;
